// src/pages/WelcomePage.js
import React from "react";
import "./WelcomePage.css"; // we'll create this next

const WelcomePage2 = () => {
  return <div className="welcome-container">
    
  </div>;
};

export default WelcomePage2;
